<script>
  import { customer } from "$lib/state/customer";
  import { cart } from "$lib/state/cart.js";
  import { cartTotals } from "$lib/state/cartTotals";
  import { getRecaptcha } from "$lib/utils/getRecaptcha";
  import { VerifyEmailAddress } from "$lib/utils/verifyEmailAddress";
  import { dispatchCustomEvent, LOGIN } from "$lib/utils/events";

  /**@type {String}*/
  let email = "";
  /**@type {string}*/
  let password;
  let msgError = "";
  /**@param {any}e*/
  const submit = async (e) => {
    const formData = new FormData(e.currentTarget);
    try {
      const recaptcha = await getRecaptcha();
      const customerSigninResponse = await fetch("/customers/signin", {
        method: "POST",
        headers: {
          "X-ReCaptcha": recaptcha,
        },
        body: formData,
      });
      const response = await customerSigninResponse.json();

      if (customerSigninResponse.status == 200) {
        customer.set(response.magentoCustomer);
        cart.set(response.customerCart);
        cartTotals.set(response.cartTotals);
        dispatchCustomEvent(LOGIN, response.magentoCustomer.customer.email);
        /** @type {HTMLDialogElement | ??}*/
        let dialog = document.getElementById("signin-account");
        dialog.close();
      } else {
        msgError = response.message;
      }
    } catch (error) {
      /**@ts-ignore*/
      msgError = error;
    }
  };

  const closeModal = () => {
    /**@type {HTMLModElement | ??}*/
    const modalSignin = document.querySelector("#signin-account");
    modalSignin.close();
  };
</script>

<div class="form-content">
  <h1>Sign In</h1>
  {#if !VerifyEmailAddress(email).isValid && VerifyEmailAddress(email).msg && email.length > 0}
    <p class="message red">{VerifyEmailAddress(email).msg}</p>
  {:else if msgError !== ""}
    <p class="message red">{msgError}</p>
  {:else}
    <p class="message"></p>
  {/if}
  <form on:submit|preventDefault={(e) => submit(e)} method="POST">
    <input
      type="e-mail"
      bind:value={email}
      name="username"
      placeholder="E-mail"
      class:wrong={!VerifyEmailAddress(email).isValid && email.length > 0}
    />
    <div class="password-content">
      <input
        type="password"
        name="password"
        placeholder="Password"
        bind:value={password}
      />
    </div>
    <a href="/forget-password" on:click={closeModal}>
      Forgot your password?*
    </a>
    <br />
    <button type="submit" class="btn-action-url">
      <span>Sign In</span>
    </button>
  </form>
</div>

<style>
  .form-content {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: 10rem 5rem 1fr;
    justify-items: center;
    gap: 1rem;
  }
  .form-content h1 {
    font-size: clamp(2rem, 5svw, 5rem);
    font-family: sirenia;
    color: var(--orange);
  }
  .message {
    font-size: 1.6rem;
    opacity: 0;
    transition: all 500ms ease;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    border-radius: 4rem;
    line-height: 1;
    padding: 0 3rem;
  }
  .message.red {
    color: var(--white);
    background-color: var(--red);
    opacity: 1;
  }
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 60rem;
    margin: 0 auto;
    gap: 2rem;
  }
  form input {
    border: none;
    width: 100%;
    padding: 2rem 0;
    text-align: center;
    border-bottom: 0.2rem solid var(--orange);
    font-size: 1.8rem;
    font-family: sirenia;
    outline: none;
    color: var(--orange);
  }
  form .password-content {
    width: 100%;
    position: relative;
  }
  form input.wrong {
    color: var(--red);
    border-bottom: 0.2rem solid var(--red);
  }
  form a {
    font-size: 2rem;
    text-decoration: none;
    color: var(--orange);
    padding: 1rem;
    margin-top: 4rem;
    position: relative;
  }
  form a::before {
    content: "";
    width: 100%;
    height: 0.2rem;
    background-color: var(--orange);
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 1rem;
    transition: all 300ms ease;
  }
</style>
